import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Rating, Star } from "@smastrom/react-rating";

import api from "../functions/api";
import config from "../configs";
import icons from "../constants/icons";

import "@smastrom/react-rating/style.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import Page from "../components/page";
import List from "../components/list";

// SwiperCore.use([Pagination, Autoplay]);

const Details = () => {
  const [data, setData] = useState(null);
  const { id } = useParams();

  const details = data?.details;
  const similar = data?.similar;

  const getData = async () => {
    try {
      const data = await api.get(`/movie-details/${id}`);
      setData(data);
    } catch (err) {
      console.error("Error fetching movie details:", err);
    }
  };

  useEffect(() => {
    id && getData();
    document.querySelector(".page")?.scrollTo(0, 0);
  }, [id]);

  return (
    <Page
      title={
        details?.title &&
        `${config.appName} - ${details?.title?.split("480")?.[0] || ""}`
      }
      canonical={config.domain + details?.path}
      // featureImg={details?.image && `${config.apiBaseURL}${details?.image}`}
      className="download-page"
    >
      <div className="Download">
        <div className="salug">
          {config.appName} » {details?.category} » {details?.title}
        </div>

        <div className="movieDown">
          <div className="right">
            <div>
              <div className="date">{details?.date}</div>
            </div>

            <div className="movieName">{details?.title?.split("480")?.[0]}</div>

            <br />

            <div className="movieRat">
              {details?.image && <img src={`${details?.image}`} alt="Poster" />}

              <div className="rating">
                <div className="text">{details?.title}</div>

                <div className="movDate">{details?.date}</div>

                <div className="rat">
                  <div className="ratText">
                    {parseFloat(details?.rating).toFixed(1)}
                  </div>

                  <div className="voter">
                    <Rating
                      className="star"
                      value={details?.rating}
                      items={10}
                      readOnly
                      itemStyles={{
                        itemShapes: Star,
                        itemStrokeWidth: 1,
                        activeFillColor: "#ffb700",
                        activeStrokeColor: "#ffb700",
                        inactiveFillColor: "transparent",
                        inactiveStrokeColor: "#ffb700",
                      }}
                    />
                    <div className="user">
                      <img
                        src={icons.user}
                        alt="User Icon"
                        className="userIcon"
                      />
                      {details?.votes} votes
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="info">MOVIE INFO</div>

            <div className="movieInfo">
              {details?.info?.map((item, index) => (
                <div className="allInfo" key={index}>
                  {item?.label}: <span>{item?.value}</span>
                </div>
              ))}
            </div>

            <br />

            <div className="download">
              {/* <Link href={`/${id}/download`} className={styles.btn}>
                <Image src={icons.down} />
                Watch/Download
              </Link> */}

              {details?.downloadLinks?.map((item, index) => {
                return (
                  <>
                    <h3 className="download-ttt">
                      {item.title || "Download Links"}
                    </h3>
                    <br />

                    {item?.links?.map((item, index) => (
                      <Link
                        to={`/media/${btoa(item.link)}`}
                        // target="_blank"
                        className="download-a"
                        key={index}
                        rel="nofollow"
                      >
                        <div className="download-title">
                          » {item.title}{" "}
                          <span className="download-size">({item.size})</span>
                        </div>
                      </Link>
                    ))}
                  </>
                );
              })}
            </div>
          </div>

          <div className="left">
            <div className="similar">Similar Titles</div>
            <List data={similar} padding={0} />
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Details;
